import { render, staticRenderFns } from "./index.vue?vue&type=template&id=211f81e0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=211f81e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f81e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211f81e0')) {
      api.createRecord('211f81e0', component.options)
    } else {
      api.reload('211f81e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=211f81e0&scoped=true", function () {
      api.rerender('211f81e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileUpload/index.vue"
export default component.exports